export default __webpack_public_path__ + "static/media/wb80.056f3192.png";